/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import { BaseButton, useTableColumn } from 'xrk-components';
import { date, fen2yuan, fillDecimal, maskAllMethod } from '@/utils/formatter';
import { ORDER_PRICE_TYPE, PAY_TYPE } from '../constants';
import { translator } from '@/utils';
import { useRouter } from 'vue-router';

/** 序号 */
export const indexCol = useTableColumn({
  type: 'index',
  label: '序号'
});

/** 订单编号 */
export const orderNoCol = useTableColumn({
  label: '项目订单编号',
  prop: 'orderNo',
  minWidth: 250,
  render: ({ cellValue }) => {
    const router = useRouter();
    return (
      <>
        <BaseButton
          type="text"
          onClick={() => {
            router.push({
              path: '/main/asp/labor-order',
              query: {
                orderNo: cellValue,
                pageName: 'finished'
              }
            });
          }}
        >
          {cellValue}
        </BaseButton>
      </>
    );
  }
});

/** 个体工商户名称 */
export const individualNameCol = useTableColumn({
  label: '个体工商户名称',
  prop: 'individualName',
  minWidth: 300
});

/** 终端服务人员 */
export const fullNameCol = useTableColumn({
  label: '终端服务人员',
  prop: 'userName',
  formatter: ({ cellValue }) => maskAllMethod({ type: 'name', val: cellValue })
});

/** 手机号 */
export const phoneCol = useTableColumn({
  label: '手机号',
  prop: 'phone',
  formatter: ({ cellValue }) => maskAllMethod({ type: 'phone', val: cellValue })
});

/** 身份证号 */
export const cardNumberCol = useTableColumn({
  label: '身份证号',
  prop: 'cardNumber',
  width: 200
});

/** 终端结算单价（元） */
export const taskPriceCol = useTableColumn({
  label: '终端结算单价（元）',
  prop: 'terminalSettlementPrice',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 终端结算金额（元） */
export const projectPayPriceCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'terminalSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 项目名称 */
export const projectNameCol = useTableColumn({
  label: '项目名称',
  prop: 'projectName',
  minWidth: 300
});

/** 项目编码 */
export const projectNoCol = useTableColumn({
  label: '项目编码',
  prop: 'projectCode',
  minWidth: 150
});

/** 工业名称 */
export const entpNameCol = useTableColumn({
  label: '工业名称',
  prop: 'industryName',
  minWidth: 300
});

/** 服务商名称 */
export const aspNameCol = useTableColumn({
  label: '服务商名称',
  prop: 'aspName',
  minWidth: 300
});

/** 服务商税款预扣时间 */
export const aspDeductionTimeCol = useTableColumn({
  label: '服务商税款预扣时间',
  prop: 'aspDeductionTime',
  minWidth: 180,
  formatter: ({ cellValue }) => date(cellValue)
});

/** 终端到账时间 */
export const endPointFinishPayAtCol = useTableColumn({
  label: '终端到账时间',
  prop: 'terminalAccountTime',
  minWidth: 180,
  formatter: ({ cellValue }) => date(cellValue)
});

/** 订单类型 */
export const orderTypeCol = useTableColumn({
  label: '订单类型',
  prop: 'orderType',
  formatter({ cellValue }) {
    return ORDER_PRICE_TYPE[cellValue]?.label;
  }
});
/** 支付方式 */
export const payTypeCol = useTableColumn({
  label: '支付方式',
  prop: 'payType',
  formatter({ cellValue }) {
    return PAY_TYPE[cellValue]?.label;
  }
});

/** 支付通道 */
export const payPassagewayCol = useTableColumn({
  label: '支付通道',
  prop: 'payPassagewayName'
});

/** 终端结算金额（元） */
export const csoPriceSumCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'terminalSettlementAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 本月累计收入（元） */
export const cumMoneyCol = useTableColumn({
  label: '本月累计收入（元）',
  prop: 'cumMoney',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 累计费用（元） */
export const cumFeeCol = useTableColumn({
  label: '累计费用（元）',
  prop: 'cumFee',
  formatter: ({ cellValue }) =>
    fillDecimal(translator.fen2yuan(cellValue / 10, false), 3)
});

/** 月度减除费用（元） */
export const monthDeductFeeCol = useTableColumn({
  label: '月度减除费用（元）',
  prop: 'monthDeductFee',
  formatter: ({ cellValue }) =>
    fillDecimal(translator.fen2yuan(cellValue / 10, false), 3)
});

/** 累计实际减除费用（元） */
export const cumDeductFeeCol = useTableColumn({
  label: '累计实际减除费用（元）',
  prop: 'cumDeductFee',
  formatter: ({ cellValue }) =>
    fillDecimal(translator.fen2yuan(cellValue / 10, false), 3)
});

/** 累计可减除费用（元） */
export const cumDeductFeeExpectCol = useTableColumn({
  label: '累计可减除费用（元）',
  prop: 'cumDeductFeeExpect',
  formatter: ({ cellValue }) =>
    fillDecimal(translator.fen2yuan(cellValue / 10, false), 3)
});

/** 月度免税收入（元） */
export const monthTaxFreeCol = useTableColumn({
  label: '月度免税收入（元）',
  prop: 'monthTaxFree',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 累计免税收入（元） */
export const cumTaxFreeCol = useTableColumn({
  label: '累计免税收入（元）',
  prop: 'cumTaxFree',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 月度依法确定的其他扣除（元） */
export const monthOtherDeductCol = useTableColumn({
  label: '月度依法确定的其他扣除（元）',
  prop: 'monthOtherDeduct',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 累计依法确定的其他扣除（元） */
export const cumOtherDeductCol = useTableColumn({
  label: '累计依法确定的其他扣除（元）',
  prop: 'cumOtherDeduct',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 应预缴所得额（元） */
export const prepaidIncomeTaxCol = useTableColumn({
  label: '应预缴所得额（元）',
  prop: 'prepaidIncomeTax',
  formatter: ({ cellValue }) =>
    fillDecimal(translator.fen2yuan(cellValue / 10, false), 3)
});

/** 适用税率 */
export const taxRateCol = useTableColumn({
  label: '适用税率（%）',
  prop: 'taxRate'
});

/** 速算扣除数（元） */
export const quickDeductCol = useTableColumn({
  label: '速算扣除数（元）',
  prop: 'quickDeduct',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 月度减免税额（元） */
export const monthDeductTaxCol = useTableColumn({
  label: '月度减免税额（元）',
  prop: 'monthDeductTax',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 累计减免税额（元） */
export const cumDeductTaxCol = useTableColumn({
  label: '累计减免税额（元）',
  prop: 'cumDeductTax',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 累计已预缴税额（元） */
export const cumPrepaidTaxAmountCol = useTableColumn({
  label: '累计已预缴税额（元）',
  prop: 'cumPrepaidTaxAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 应预缴个人所得税额（元） */
export const prepaidTaxAmountCol = useTableColumn({
  label: '应预缴个人所得税额（元）',
  prop: 'prepaidTaxAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});

/** 税后收入（元） */
export const taxAfterAmountCol = useTableColumn({
  label: '税后收入（元）',
  prop: 'taxAfterAmount',
  formatter: ({ cellValue }) => fen2yuan(cellValue)
});
